import { useUI } from '@/contexts/UIContext';
import { MagnifyingGlassIcon } from '@/icons';

/**
 * The top-bar search affordance. It does not search inline; it opens the
 * command palette (which does the real querying) — matching the Linear/GitHub
 * pattern. Shows the Cmd-K hint on wider screens.
 */
export function SearchBar() {
  const { setCommandOpen } = useUI();
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

  return (
    <button
      type="button"
      onClick={() => setCommandOpen(true)}
      className="flex h-9 w-full max-w-xs items-center gap-2 rounded-lg border border-border bg-surface px-3 text-sm text-fg-subtle transition-colors hover:border-fg-subtle hover:text-fg-muted"
      aria-label="Search (open command palette)"
    >
      <MagnifyingGlassIcon className="h-4 w-4" />
      <span className="flex-1 text-left">Search…</span>
      <kbd className="hidden rounded border border-border bg-surface-raised px-1.5 py-0.5 font-mono text-xs text-fg-subtle sm:inline">
        {isMac ? '⌘' : 'Ctrl'} K
      </kbd>
    </button>
  );
}
